<div class="statement-builder-flyout" [ngClass]="{'standalone-mode': !embeddedMode, 'embedded-mode': embeddedMode}">
  <p class="statement-builder-header">
    @if (!frameToBeEditedId) {
      <i class="fa-solid"
        [ngClass]="{'fa-wrench': mode === 'options', 'fa-arrow-left': mode !== 'options', 'clickable': mode !== 'options'}"
        (click)="selectStatementBuilderOption('options')">
      </i>
    }{{statementBuilderHeaderText}}</p>

    @if (mode === 'options') {
      <div>
        <p class="statement-builder-options-header">Select what you would like to accomplish:</p>
        @for (statementBuilderOption of statementBuilderOptions; track statementBuilderOption) {
          <div class="row statement-builder-option-tile"
            [ngClass]="{'is-disabled': statementBuilderOption.disabled, 'clickable': !statementBuilderOption.disabled}"
            title="{{statementBuilderOption.disabled ? 'No data exists to build statement from' : ''}}"
            (click)="selectStatementBuilderOption(statementBuilderOption.mode)">
            <div class="col col-11">
              <p class="statement-builder-option-title">{{statementBuilderOption.title}}</p>
              <p class="statement-builder-option-sub-title">{{statementBuilderOption.subtitle}}</p>
            </div>
            <div class="col col-1"><i class="fa-solid fa-arrow-right fa-xl statement-builder-option-tile-icon"></i></div>
          </div>
        }
      </div>
    }
    @if (mode === 'consolidate') {
      <div>
        <app-consolidate-periods-form
          [company]="company"
          [columns]="columnsForConsolidation"
          [rows]="rows"
          [frameToBeEditedId]="frameToBeEditedId"
          (closeConsolidatedPeriods)="close($event)"
        ></app-consolidate-periods-form>
      </div>
    }
    @if (mode === 'calc-missing-period') {
      <div>
        <app-calculate-missing-period-form
          [company]="company"
          [columns]="columnsForMissingPeriodCalcs"
          [rows]="rows"
          [frameToBeEditedId]="frameToBeEditedId"
          (closeMissingStatementForm)="close($event)"
        ></app-calculate-missing-period-form>
      </div>
    }
    @if (mode === 'generate-forecast' || mode === 'duplicate-forecast') {
      <div>
        <app-generate-forecast-form
          [company]="company"
          [columns]="columns"
          [rows]="rows"
          [spreadingTemplateItems]="spreadingTemplateItems"
          [frameToBeEditedId]="frameToBeEditedId"
          [isDuplicateMode]="mode === 'duplicate-forecast'"
          (closeGeneratePeriods)="close($event)"
        ></app-generate-forecast-form>
      </div>
    }
    @if (mode === 'annualize-period') {
      <div>
        <app-annualize-period-form
          [company]="company"
          [columns]="columns"
          [rows]="rows"
          (closeAnnualizePeriodForm)="close($event)"
        ></app-annualize-period-form>
      </div>
    }
    @if (mode === 'options') {
      <div class="footer text-end">
        <button class="btn btn-link" (click)="close()">Cancel</button>
      </div>
    }
  </div>
